(() => {
  const ACTIVE_CLASS = 'is-active';

  const getImageData = (swatch, swatches) => {
    const imageSrc = swatch.getAttribute('data-image-src');
    const imageSrcset = swatch.getAttribute('data-image-srcset');
    const imageAlt = swatch.getAttribute('data-image-alt');
    const imageId = swatch.getAttribute('data-image-id');
    const mediaId = swatch.getAttribute('data-media-id');

    if (imageSrc || imageId || mediaId) {
      return { imageSrc, imageSrcset, imageAlt, imageId, mediaId };
    }

    return {
      imageSrc: swatches.getAttribute('data-default-image-src'),
      imageSrcset: swatches.getAttribute('data-default-image-srcset'),
      imageAlt: swatches.getAttribute('data-default-image-alt'),
      imageId: swatches.getAttribute('data-default-image-id'),
      mediaId: null,
    };
  };

  const updateCardLabel = (swatches, swatch) => {
    const label = swatches.querySelector('[data-js-product-card-swatch-label]');
    const color = swatch.getAttribute('data-color');
    if (!label || !color) return;

    const template = swatches.getAttribute('data-label-template');
    if (template && template.includes('__COLOR__')) {
      label.textContent = template.replace('__COLOR__', color);
      return;
    }

    const prefix = (template || label.textContent).replace(/:\s*.*$/, '').replace(/:\s*$/, '');
    label.textContent = `${prefix}: ${color}`;
  };

  const updateCardImage = (productItem, swatch, swatches) => {
    const { imageSrc, imageSrcset, imageAlt, imageId, mediaId } = getImageData(swatch, swatches);
    const variantUrl = swatch.getAttribute('data-variant-url');

    const imageContainer = productItem.querySelector('[data-js-product-item-image]');
    if (!imageContainer) return;

    let changedViaSlider = false;
    const slider = imageContainer.querySelector('css-slider');

    if (slider && (imageId || mediaId)) {
      const slide =
        (imageId && slider.querySelector(`.product-item__image-${imageId}`)) ||
        (mediaId && slider.querySelector(`.product-item__image-${mediaId}`)) ||
        (mediaId && slider.querySelector(`[data-media-id="${mediaId}"]`));

      if (slide && typeof slider.changeSlide === 'function' && slide.dataset.index != null) {
        slider.changeSlide(slide.dataset.index);
        changedViaSlider = true;
      }
    }

    if (!changedViaSlider && imageSrc) {
      const img = imageContainer.querySelector('.product-item__image-figure img, img');
      if (img) {
        img.src = imageSrc;
        if (imageSrcset) {
          img.srcset = imageSrcset;
        } else {
          img.removeAttribute('srcset');
        }
        if (imageAlt) img.alt = imageAlt;
        img.parentElement?.classList.add('lazyloaded');
      }
    }

    if (variantUrl) {
      productItem.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        if (link.closest('[data-js-product-card-swatches]')) return;
        link.href = variantUrl;
      });
    }
  };

  const updateSwatchNav = (slider) => {
    const track = slider.querySelector('[data-js-product-card-swatches-track]');
    const prev = slider.querySelector('[data-js-product-card-swatches-prev]');
    const next = slider.querySelector('[data-js-product-card-swatches-next]');
    if (!track || !prev || !next) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const canScroll = maxScroll > 2;

    prev.hidden = !canScroll || track.scrollLeft <= 2;
    next.hidden = !canScroll || track.scrollLeft >= maxScroll - 2;
  };

  const initSwatchSlider = (slider) => {
    if (slider.dataset.swatchesReady) return;
    slider.dataset.swatchesReady = 'true';

    const track = slider.querySelector('[data-js-product-card-swatches-track]');
    const prev = slider.querySelector('[data-js-product-card-swatches-prev]');
    const next = slider.querySelector('[data-js-product-card-swatches-next]');
    if (!track || !prev || !next) return;

    const scrollByAmount = () => Math.max(track.clientWidth * 0.75, 80);

    prev.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
    });

    next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => updateSwatchNav(slider), { passive: true });
    window.addEventListener('resize', () => updateSwatchNav(slider), { passive: true });
    updateSwatchNav(slider);
  };

  const initAllSwatchSliders = (root = document) => {
    root.querySelectorAll('[data-js-product-card-swatches-slider]').forEach(initSwatchSlider);
  };

  const onSwatchClick = (event) => {
    const swatch = event.target.closest('[data-js-product-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const productItem = swatch.closest('[data-js-product-item]');
    const swatches = swatch.closest('[data-js-product-card-swatches]');
    if (!productItem || !swatches) return;

    swatches.querySelectorAll('[data-js-product-card-swatch]').forEach((button) => {
      button.classList.toggle(ACTIVE_CLASS, button === swatch);
    });

    updateCardLabel(swatches, swatch);
    updateCardImage(productItem, swatch, swatches);
  };

  document.addEventListener('click', onSwatchClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSwatchSliders());
  } else {
    initAllSwatchSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllSwatchSliders(event.target);
  });
})();
